module.exports = __webpack_public_path__ + "logobiciregistro.6283f5bed9fc5aa6fb3c.png";


//////////////////
// WEBPACK FOOTER
// C:/Biciregistro/workspace/biciregistro - angular/src/assets/images/logobiciregistro.png
// module id = ../../../../../src/assets/images/logobiciregistro.png
// module chunks = styles